/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * FormatOutdentIcon
 */
export default class FormatOutdentIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M7 1.911a1 1 0 01.993.884L8 2.91V20.96a1 1 0 01-1.993.117L6 20.959V2.911a1 1 0 011-1zM21.35 17c.39 0 .65.4.65 1s-.26 1-.65 1H9.65c-.39 0-.65-.4-.65-1s.26-1 .65-1zm0-4c.39 0 .65.4.65 1s-.26 1-.65 1H9.65c-.39 0-.65-.4-.65-1s.26-1 .65-1zM3.65 9.53c.746-.616 1.35-.329 1.35.64v3.661c0 .973-.604 1.255-1.35.64l-2.215-1.83c-.436-.36-.43-.928 0-1.281zM21.35 9c.39 0 .65.4.65 1s-.26 1-.65 1H9.65c-.39 0-.65-.4-.65-1s.26-1 .65-1zm0-4c.39 0 .65.4.65 1s-.26 1-.65 1H9.65C9.26 7 9 6.6 9 6s.26-1 .65-1z" fillRule="evenodd"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

